import { Component, Inject, OnInit } from '@angular/core';


import { WidgetsService } from '../../services/widgets.service';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss'],
  providers: [
    { provide: MAT_TOOLTIP_SCROLL_STRATEGY, 
      useFactory: (scrollStrategyOptions: ScrollStrategyOptions) => scrollStrategyOptions.noop,
      deps: [ScrollStrategyOptions] 
    } // Disable tooltip scroll strategy to avoid issues with dialog scrolling
  ]
})
export class DialogWrapperWidgetComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private _widgetService: WidgetsService,
    private _translate: TranslateService) {
    this._translate.setDefaultLang(localStorage.getItem('language') || 'en');
    }

  ngOnInit() {
  }

  exportData() {
    this._widgetService.exportDataInCsv(this.data.data, this.data.columns);
  }

  exportDataExcel() {
    this._widgetService.exportDataInXlsx(this.data.data, this.data.columns);
  }
}
